import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';
import ShopListRow from '../shop_list/shop_list_row';
import grubhubLogo from "../../assets/GH_Logotype_Rebrand_Orange_RGB.svg";

const hallListPanelWrapper = {
    "width":"100%",
};

const hallPanelCourtTitle = {
    "fontSize": "2vh",
    "fontFamily": "GraphikMedium"
};

const mainLogoStyle = {
    "margin": "auto",
    "width": "50%",
};

const shopListStyle = {
    fontSize: "1.05vh"
}

function calculateListItemHeights(shopCount){
    if(shopCount === 0) {
        return "0%";
    } else if(shopCount <= 2) {
        return "65%";
    } else if (shopCount <= 4) {
        return "42%";
    } else {
        return "31.5%";
    }
}


@inject('RootStore')
@observer
export default class HorizontalHallListPanel extends Component {
    render() {
        let currentStylesDict = this.props.RootStore.styleStore.currentStylesDict;
        let hallStore = this.props.RootStore.hallStore;
        let shopList = [];
        let shopListItemsToBeRendered = Math.min(this.props.RootStore.hallStore.shopListLength-1,6);
        for(let i = 0; i < shopListItemsToBeRendered; i+=2) {
            shopList.push(<Flexbox height="3%" flexGrow={.5} key={i + this.props.RootStore.hallStore.shopsList.length+3}></Flexbox>);
            shopList.push(<Flexbox height={calculateListItemHeights(shopListItemsToBeRendered)} key={i}><ShopListRow shop1={this.props.RootStore.hallStore.shopsList[i]} shop2={this.props.RootStore.hallStore.shopsList[i + 1]}/></Flexbox> )
        }
        return (
            <Flexbox height={this.props.mainHeight} style={hallListPanelWrapper} >
                <Flexbox height="100%" width="100%" flexDirection="column" className={currentStylesDict.hallPanelMainBackgroundClassName} style={currentStylesDict.hallPanelMainBackgroundColor}>
                    <Flexbox width="100%" height="1%" flexGrow={.3}></Flexbox>
                    <Flexbox width="100%" height="21%" flexDirection="row">
                        <Flexbox width="45%" height="100%">
                            <div style={mainLogoStyle}>
                                <img src={grubhubLogo} color={'#FF8000'} alt="" width="100%"/>
                            </div>
                        </Flexbox>
                        <Flexbox width="5%" height="100%" flexGrow={1}></Flexbox>
                        <Flexbox width="45%" height="100%" style={hallPanelCourtTitle} flexDirection="column">
                            <Flexbox width="100%" height="9%" flexGrow={1}>
                                <div style={{margin: 'auto'}}>
                                    {hallStore.foodCourtName}
                                </div>
                            </Flexbox>
                        </Flexbox>
                    </Flexbox>
                    <Flexbox width="100%" height="65%" flexDirection="column" flexGrow={1} style={shopListStyle}>
                        {shopList}
                    </Flexbox>
                    <Flexbox width="100%" height="2%" flexGrow={.5}></Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_panel/hall_panel_vertical_layout.jsx